import { render, staticRenderFns } from "./OtherReceiptPaymentFilter.vue?vue&type=template&id=36ec8c41"
import script from "./OtherReceiptPaymentFilter.vue?vue&type=script&lang=js"
export * from "./OtherReceiptPaymentFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports